var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPDashCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 11.499H22.0002C22.0002 6.369 18.1272 2.5 12.9902 2.5V4.5C17.0522 4.5 20.0002 7.443 20.0002 11.499Z",
    fill: "#4E26A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 8.50024C15.1028 8.50024 15.9998 9.39724 15.9998 11.5002H17.9998C17.9998 8.27524 16.2248 6.50024 12.9998 6.50024V8.50024ZM16.4218 13.9432C16.2296 13.7686 15.9771 13.6754 15.7176 13.6835C15.4581 13.6915 15.2118 13.8001 15.0308 13.9862L12.6378 16.4472C12.0618 16.3372 10.9038 15.9762 9.71179 14.7872C8.51979 13.5942 8.15879 12.4332 8.05179 11.8612L10.5108 9.46724C10.6972 9.28637 10.8059 9.04006 10.814 8.78045C10.822 8.52083 10.7287 8.26828 10.5538 8.07624L6.85879 4.01324C6.68384 3.8206 6.44067 3.70374 6.18095 3.6875C5.92122 3.67125 5.66539 3.7569 5.46779 3.92624L3.29779 5.78724C3.1249 5.96075 3.02171 6.19169 3.00779 6.43624C2.99279 6.68624 2.70679 12.6082 7.29879 17.2022C11.3048 21.2072 16.3228 21.5002 17.7048 21.5002C17.9068 21.5002 18.0308 21.4942 18.0638 21.4922C18.3083 21.4786 18.5391 21.3749 18.7118 21.2012L20.5718 19.0302C20.7413 18.8328 20.8271 18.577 20.811 18.3173C20.795 18.0576 20.6783 17.8143 20.4858 17.6392L16.4218 13.9432Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDashCall);
export default __webpack_public_path__ + "static/media/p_dash_call.8f9b7887a631618292c070e6624fbed2.svg";
export { ForwardRef as ReactComponent };